import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IDetailsControl } from '../models/details-control';


@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialogStates: { [key: string]: BehaviorSubject<IDetailsControl> } =
    {};

  constructor() {}

  getDialogState(id: string): Observable<IDetailsControl> {
    if (!this.dialogStates[id]) {
      this.dialogStates[id] = new BehaviorSubject<IDetailsControl>({
        isOpen: false,
        isEditing: false,
        param: '',
      });
    }
    return this.dialogStates[id].asObservable();
  }

  setDialogState(id: string, state: IDetailsControl): void {
    if (!this.dialogStates[id]) {
      this.dialogStates[id] = new BehaviorSubject<IDetailsControl>(state);
    } else {
      this.dialogStates[id].next(state);
    }
  }

  openDialog(id: string, param: any = ''): void {
    this.setDialogState(id, { isOpen: true, isEditing: false,param });
  }

  closeDialog(id: string): void {
    this.setDialogState(id, { isOpen: false, isEditing: false,param:'' });
  }

  setEditingState(id: string, isEditing: boolean): void {
    const currentState = this.dialogStates[id]?.value;
    if (currentState) {
      this.setDialogState(id, { ...currentState, isEditing });
    }
  }

  getDialogParam(id: string): string | undefined {
    return this.dialogStates[id]?.value.param;
  }
}
